function getCartPieceCount(cart) {
  if (!cart || !Array.isArray(cart.items)) return 0;

  // Main products only: a line's quantity already equals its main-product count.
  return cart.items.reduce(function (total, item) {
    return total + (Number(item.quantity) || 0);
  }, 0);
}

function readCartPieceCountFromRoot(root) {
  if (!root || typeof root.querySelector !== 'function') return null;

  const dataEl = root.querySelector('[data-cart-piece-count]');
  if (dataEl) {
    const raw = dataEl.getAttribute('data-cart-piece-count');
    if (raw !== null && raw !== '') {
      const parsed = parseInt(raw, 10);
      if (!isNaN(parsed)) return parsed;
    }
  }

  const heading = root.querySelector('.item-count');
  if (heading) {
    const headingMatch = heading.textContent.trim().match(/^(\d+)/);
    if (headingMatch) return parseInt(headingMatch[1], 10);
  }

  const cartNumberEl = root.querySelector('#cart_number');
  if (cartNumberEl) {
    const cartNumberMatch = cartNumberEl.textContent.match(/\((\d+)\)/);
    if (cartNumberMatch) return parseInt(cartNumberMatch[1], 10);
  }

  return null;
}

function parsePieceCountFromHtml(html) {
  if (!html) return null;
  const container = document.createElement('div');
  container.innerHTML = html;
  return readCartPieceCountFromRoot(container);
}

function readLiquidCartPieceCount() {
  return readCartPieceCountFromRoot(document);
}

function updateCartCountDisplays(cart, options) {
  options = options || {};
  const isEmpty = !cart || cart.item_count === 0;
  const liquidCount =
    options.pieceCount != null ? options.pieceCount : readLiquidCartPieceCount();
  const count = liquidCount != null ? liquidCount : getCartPieceCount(cart);

  // Cache the last-known count so a back/forward restore can paint it instantly
  // (see pageshow handler) instead of showing the stale server HTML then jumping.
  try {
    localStorage.setItem('cart_piece_count', isEmpty ? '0' : String(count));
  } catch (e) {}

  if (typeof jQuery !== 'undefined') {
    jQuery('#cart_number').html('(' + count + ') Cart');
    jQuery('#cart_number_mobi').html(isEmpty ? '0' : String(count));
  }

  const stickyItem = document.getElementById('sticky_cart_item');
  const stickyCart = document.getElementById('sticky-cart');
  if (stickyItem) stickyItem.textContent = isEmpty ? '0' : String(count);
  if (stickyCart) stickyCart.setAttribute('data-cart', isEmpty ? '0' : String(count));

  document.querySelectorAll('.cart-bubble').forEach(function (bubble) {
    bubble.classList.toggle('visually-hidden', isEmpty);

    const textCount = bubble.querySelector('.cart-bubble__text-count');
    if (textCount) {
      const limitAttr = textCount.getAttribute('data-bubble-limit');
      const limit = limitAttr ? Number(limitAttr) : null;
      if (isEmpty) {
        textCount.textContent = '';
      } else if (limit && count >= limit) {
        textCount.textContent = '';
      } else {
        textCount.textContent = String(count);
      }
    }

    const a11y = bubble.querySelector('.cart-bubble__text .visually-hidden');
    if (a11y) {
      a11y.textContent = a11y.textContent.replace(/[\d]+\s*$/, isEmpty ? '0' : String(count));
    }
  });
}
